module.exports = __webpack_public_path__ + "img/tif.27b20813.svg";